import {
  chakra,
  forwardRef,
  RadioProps as ChakraRadioProps,
  useMultiStyleConfig,
  useRadio,
  useRadioGroupContext,
} from '@chakra-ui/react';
import { omitThemingProps } from '@chakra-ui/styled-system';

type RadioInputProps = ChakraRadioProps['inputProps'] & {
  'data-testid'?: string;
};

export interface FilterSwitchProps extends Omit<ChakraRadioProps, 'inputProps'> {
  inputProps?: RadioInputProps;
}

const FilterSwitch = forwardRef<FilterSwitchProps, 'input'>((props, ref) => {
  const group = useRadioGroupContext();
  const { value: valueProp } = props;

  const styles = useMultiStyleConfig('FilterSwitch');

  const ownProps = omitThemingProps(props);

  const {
    children,
    inputProps: htmlInputProps,
    isDisabled = group?.isDisabled,
    isFocusable = group?.isFocusable,
    ...rest
  } = ownProps;

  const isChecked = group.value === valueProp;

  const { name } = group;

  const { getRadioProps, getInputProps, getLabelProps } = useRadio({
    ...rest,
    isChecked,
    isDisabled,
    isFocusable,
    name,
    onChange: group.onChange,
  });

  return (
    <chakra.label {...getLabelProps()} {...getRadioProps()} __css={styles.item}>
      <chakra.input {...getInputProps(htmlInputProps, ref)} />
      {children}
    </chakra.label>
  );
});

export default FilterSwitch;
